var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v(" "+_vm._s(_vm.label)+" "),_c('v-text-field',_vm._g(_vm._b({attrs:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}},'v-text-field',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }